import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import qs from 'query-string'
import { getBlock } from '../../api/blockApi'
import { postNewsletterSubscription } from '../../api/newsletterApi'

/**
 * NOTE:
 * This component is a complete hack to support the original way Selligent works.
 * We hook into the form submit and manually trigger our own submit to allow submitting with Ajax instead of a page change.
 */
class SelligentBlock extends React.Component {
  state = {
    error: false,
    form: null
  }

  constructor (props) {
    super(props)

    this.formRef = React.createRef()
  }

  componentDidMount = () => {
    const { location } = this.props
    const params = qs.parse(location.search)

    getBlock(this.props.id, params)
      .then((response) => {
        this.setState({
          form: response.data.body
        })
      })
      .catch(() => {
        this.setState({ error: true })
      })
  }

  componentDidUpdate = () => {
    if (this.formRef.current) {
      // Find the form element in the ref
      const form = this.formRef.current.querySelector('form')
      if (!form) {
        return
      }
      form.addEventListener('submit', (e) => {
        e.preventDefault()

        // Retrieve the ID parameter of the original action attribute
        const querystring = e.target.action.split('?')
        const { ID } = qs.parse(querystring[1])

        const data = new FormData(form)

        // Trigger our own subscription endpoint with the original ID and formdata
        postNewsletterSubscription(ID, data)
          .then((response) => {
            this.setState({
              form: response.data.message
            })
          })
          .catch(() => {
            this.setState({ error: true })
          })
      })
    }
  }

  render = () => {
    const { error, form } = this.state

    if (error) {
      return (
        <div className='alert alert-danger'>
          Failed to load the newsletter subscription form
        </div>
      )
    }

    if (!form) return null

    return (
      <div className='selligent' dangerouslySetInnerHTML={{ __html: form }} ref={this.formRef} />
    )
  }
}

SelligentBlock.propTypes = {
  id: PropTypes.number,
  location: PropTypes.object
}

export default withRouter(SelligentBlock)
